// import { createHashHistory } from 'history';
// const history = createHashHistory({ basename: "/" });
import { createBrowserHistory } from 'history';
const history = createBrowserHistory({ basename: "/" });
export default history;
